import React, { useState } from "react";
import useCoupon from "../useCoupon";
import ConfirmationModal from "./ConfirmationModal";

function CouponsList({ onSetActiveTab }) {
  const {
    coupons,
    isGettingCoupons,
    getCouponsError,
    deleteCouponFn,
    isDeletingCoupon,
  } = useCoupon();
  const [deletingId, setDeletingId] = useState(null);
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    coupon: null,
  });

  if (isGettingCoupons) return <div>Loading coupons...</div>;
  if (getCouponsError)
    return <div className="text-red-500">Error loading coupons.</div>;

  const handleDelete = (coupon) => {
    setConfirmModal({ open: true, coupon });
  };

  const confirmDelete = () => {
    setDeletingId(confirmModal.coupon._id);
    deleteCouponFn(confirmModal.coupon._id, {
      onSettled: () => {
        setDeletingId(null);
        setConfirmModal({ open: false, coupon: null });
      },
    });
  };

  const cancelDelete = () => {
    setConfirmModal({ open: false, coupon: null });
  };
  function hasExpired(dateString) {
    return new Date(dateString) < new Date();
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Coupons</h2>
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
          onClick={() => onSetActiveTab("create")}
        >
          + New Coupon
        </button>
      </div>
      <div className="grid gap-6">
        {coupons && coupons.length > 0 ? (
          [...coupons].reverse().map((coupon) => (
            <div
              key={coupon._id}
              className="bg-white rounded shadow p-6 flex flex-col md:flex-row md:items-center md:justify-between"
            >
              <div className="flex-1">
                <div className="flex items-center gap-4 mb-2">
                  <span className="font-mono text-lg font-bold bg-gray-100 px-3 py-1 rounded">
                    {coupon.code}
                  </span>
                  <span className="text-sm text-gray-500">{coupon.name}</span>
                  <span className="px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
                    {coupon.target === "all" ? "All Users" : coupon.target}
                  </span>
                </div>
                <div className="flex flex-wrap gap-4 mb-2 text-gray-700 text-sm">
                  <span>
                    <span className="font-semibold">Discount:</span>{" "}
                    {coupon.discountRate}%
                  </span>
                  <span>
                    <span className="font-semibold">Max Uses:</span>{" "}
                    {coupon.maxUses}
                  </span>
                  <span>
                    <span className="font-semibold">Used:</span>{" "}
                    {coupon.usedCount}
                  </span>
                </div>
                <div className="flex flex-wrap gap-4 text-xs text-gray-500">
                  <span>
                    <span className="font-semibold">Start:</span>{" "}
                    {coupon.startDate
                      ? new Date(coupon.startDate).toLocaleDateString()
                      : "-"}
                  </span>
                  <span>
                    <span className="font-semibold">End:</span>{" "}
                    {coupon.endDate
                      ? new Date(coupon.endDate).toLocaleDateString()
                      : "-"}
                  </span>
                </div>
              </div>
              <div className="flex flex-col gap-2 mt-4 md:mt-0 md:ml-6 items-end">
                <span
                  className={`px-2 py-1 text-xs font-semibold rounded-full ${
                    coupon.usedCount >= coupon.maxUses
                      ? "bg-red-100 text-red-800"
                      : "bg-green-100 text-green-800"
                  }`}
                >
                  {coupon.usedCount >= coupon.maxUses ||
                  hasExpired(coupon.endDate)
                    ? "Expired"
                    : "Active"}
                </span>
                <button
                  className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700 transition-colors disabled:opacity-60 disabled:cursor-not-allowed mt-2"
                  onClick={() => handleDelete(coupon)}
                  disabled={isDeletingCoupon && deletingId === coupon._id}
                >
                  {isDeletingCoupon && deletingId === coupon._id
                    ? "Deleting..."
                    : "Delete"}
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-12 text-gray-500">
            No coupons found.
          </div>
        )}
      </div>
      {/* Confirmation Modal */}
      {confirmModal.open && (
        <ConfirmationModal
          isDeletingCoupon={isDeletingCoupon}
          cancelDelete={cancelDelete}
          confirmDelete={confirmDelete}
          confirmModal={confirmModal}
        />
      )}
    </div>
  );
}

export default CouponsList;
